/**
 * @generated SignedSource<<158b791fc39d844d78fb09a2931f0a92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StopSageIntacctRecipesInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type stopSageIntacctRecipesMutation$variables = {
  input: StopSageIntacctRecipesInput;
};
export type stopSageIntacctRecipesMutation$data = {
  readonly stopSageIntacctRecipes: {
    readonly outcome: string | null;
  } | null;
};
export type stopSageIntacctRecipesMutation = {
  variables: stopSageIntacctRecipesMutation$variables;
  response: stopSageIntacctRecipesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StopSageIntacctRecipesPayload",
    "kind": "LinkedField",
    "name": "stopSageIntacctRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89d5db083ef9d4f4df395ff9fd6cba5e",
    "id": null,
    "metadata": {},
    "name": "stopSageIntacctRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation stopSageIntacctRecipesMutation(\n  $input: StopSageIntacctRecipesInput!\n) {\n  stopSageIntacctRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a8a118d2a4b9a099745b71b0fac618d";

export default node;
